import React from 'react';
import { Card, Space, Skeleton, Typography } from 'antd';
import { _T } from '../../base-react/src/Localization';
const { Title, Text } = Typography;
export const PageSkeleton = () => (React.createElement(Space, { orientation: "vertical", size: "large", style: { width: '100%', padding: 24 } },
    React.createElement("div", { style: {
            borderRadius: 0,
            padding: '16px 24px',
            boxShadow: '0 6px 20px rgba(15, 46, 93, 0.15)',
        } },
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
            React.createElement(Space, { align: "center", size: 16 },
                React.createElement("div", { style: {
                        width: 48,
                        height: 48,
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, rgba(242, 12, 181, 0.9), rgba(28, 18, 81, 0.2))',
                    } }),
                React.createElement("div", { style: {
                        width: 220,
                        height: 30,
                        borderRadius: 8,
                        background: '#dfe7fa',
                    } })),
            React.createElement(Space, { align: "center", size: 12 },
                React.createElement("div", { style: {
                        width: 80,
                        height: 10,
                        borderRadius: 4,
                        background: '#e6ecf4',
                    } })))),
    React.createElement("div", { style: {
            background: '#0f1b33',
            borderRadius: 32,
            padding: 32,
            minHeight: 360,
            boxShadow: '0 20px 40px rgba(15,46,93,0.25)',
        } },
        React.createElement(Space, { orientation: "vertical", size: "middle" },
            React.createElement(Skeleton, { active: true, title: true, paragraph: { rows: 2, width: ['60%', '80%'] } }),
            React.createElement(Skeleton, { active: true, paragraph: { rows: 3, width: ['70%', '90%', '80%'] } }))),
    React.createElement(CardSkeleton, null,
        React.createElement(Title, { level: 3, style: { marginBottom: 0 } }, _T('landing.events.title')),
        React.createElement(Text, { type: "secondary" }, _T('landing.events.description')))));
export const CardSkeleton = ({ children }) => (React.createElement(Card, { style: { borderRadius: 24, minHeight: 200 } },
    React.createElement(Space, { orientation: "vertical", size: "middle", style: { width: '100%' } },
        children,
        React.createElement(Skeleton, { active: true, paragraph: { rows: 4 } }))));
